import { render, staticRenderFns } from "./menuAuditorio.vue?vue&type=template&id=1a7684e4&scoped=true"
import script from "./menuAuditorio.vue?vue&type=script&lang=js"
export * from "./menuAuditorio.vue?vue&type=script&lang=js"
import style0 from "./menuAuditorio.vue?vue&type=style&index=0&id=1a7684e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7684e4",
  null
  
)

export default component.exports